import { useAIQuota } from 'core/hooks/useAIQuota';

export const AI_QUIZ_MAX_QUESTIONS = 10;

/** Each generated question spends one interaction, so the quiz never asks for more than the teacher has left. */
function useAIQuizMaxQuestions(): number {
  const { usage } = useAIQuota();
  if (!usage) {
    return AI_QUIZ_MAX_QUESTIONS;
  }
  const remaining = Math.max(usage.quota - usage.consumed, 0);
  return Math.min(remaining, AI_QUIZ_MAX_QUESTIONS);
}

export default useAIQuizMaxQuestions;
